import { render } from "./BackgroundTaskIndicator.vue?vue&type=template&id=34a719b7&scoped=true"
import script from "./BackgroundTaskIndicator.vue?vue&type=script&lang=js"
export * from "./BackgroundTaskIndicator.vue?vue&type=script&lang=js"

import "./BackgroundTaskIndicator.vue?vue&type=style&index=0&id=34a719b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34a719b7"]])

export default __exports__